import React from "react";
import Addmenu from "../NavMenus/Addmenu";
import Editmenu from "../NavMenus/Editmenu";
import Statusmenu from "../NavMenus/Statusmenu";
import Icon from "../../../assets/icons/Icon";
import injectSheet from "react-jss";
import FixedBackground from "../../../utils/Helpers/FixedBackground";

const NavMenu = (props) => {
  const visible = props.visibles[1] || props.visibles[2] || props.visibles[3];
  const { classes } = props;

  return (
    <div onClick={() => props.toggleSubmenu()}>
      {visible && <FixedBackground />}
      <div
        className={classes.navmenu}
        style={visible ? { width: "500px" } : null}
      >
        {visible && (
          <div className={classes.close}>
            <button onClick={() => props.toggleSubmenu()} value="-1">
              <Icon type="clear" fill="white" width="24px" />
            </button>
          </div>
        )}
        {props.visibles[1] && (
          <Addmenu toggleSubmenu={() => props.toggleSubmenu} />
        )}
        {props.visibles[2] && (
          <Editmenu toggleSubmenu={() => props.toggleSubmenu} />
        )}
        {props.visibles[3] && (
          <Statusmenu toggleSubmenu={() => props.toggleSubmenu} />
        )}
      </div>
    </div>
  );
};
const styles = (theme) => ({
  navmenu: {
    height: "100vh",
    backgroundColor: theme.menuDarkColor,
    transition: "width .45s ease",
    width: "0",
    top: 0,
    left: "64px",
    boxShadow: "7px 0 14px 0 rgba(0, 0, 0, 0.14)",
    position: "fixed",
    zIndex: "90",
    overflowX: "auto",
  },
  close: {
    textAlign: "right",
    "& button": {
      padding: "16px",
      border: "0",
      cursor: "pointer",
      backgroundColor: "transparent",
    },
  },
});
export default injectSheet(styles)(NavMenu);
